const PROVIDER_LABELS = Object.freeze({
  "musicsquare-qq": "QQ",
  "qqmusic-line2": "QQ 線路 2",
  "qqmusic-line3": "QQ 線路 3",
  yinyueku: "Yinyueku",
  "musicsquare-netease": "網易",
  "musicsquare-kuwo": "酷我",
  "qqmusic-koa": "QQ 備援",
  youtube: "YouTube",
  soundcloud: "SoundCloud",
});

const VERSION_LABELS = Object.freeze({
  original: "原版",
  dj: "DJ／混音",
  live: "Live",
  instrumental: "伴奏",
  cover: "翻唱",
  sped: "變速版",
});

/** 將 Worker 的穩定識別碼集中轉為介面名稱，避免各元件自行維護對照表。 */
export function providerLabel(id) {
  return PROVIDER_LABELS[id] || id || "Music Life";
}

export function versionLabel(value) {
  return VERSION_LABELS[value] || "其他版本";
}
